import { wordsTrimer } from "../../../utility/commonFunction";
import Images from "../../../utility/imagePaths";
import { PortfolioItemType } from "../../../utility/types/generaTypes";
import GradientIcon from "../gradientIcon/GradientIcon";
import "./PortfolioCard.css";

type PortfolioCardProps = {
  portfolio: PortfolioItemType;
};

const PortfolioCard = ({ portfolio }: PortfolioCardProps) => {
  return (
    <div className="portfolioCard_container">
      {!portfolio?.icon && <img src={portfolio?.img} alt={portfolio?.title} />}
      <div className="portfolio_secondery_container">
        {portfolio?.icon && (
          <GradientIcon
            src={portfolio?.icon}
            alt={portfolio?.title + "_icon"}
            style={{ alignSelf: portfolio.icon ? "center" : "left" }}
          />
        )}
        <h2 style={{ textAlign: portfolio.icon ? "center" : "unset" }}>
          {portfolio?.title}
        </h2>
        <p style={{ textAlign: portfolio.icon ? "center" : "unset" }}>
          {wordsTrimer(portfolio?.desc, 20)}
        </p>
        <div className="portfolio_bottom_container">
          {portfolio.data.map((item, index) => (
            <div
              key={"portfolio_points_container" + index}
              className="portfolio_points_container"
            >
              <img src={Images.SVG_TICK_ICON} alt="tick" />
              <p key={index}>{item}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PortfolioCard;
